
    const _ = require("underscore");
    module.exports = function(context){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="fullscreen-overlay__view-similar slide-control__element"><div class="fullscreen-overlay-inner"><h3 class="mb15">Sold Out</h3><a href="#relatedproducts" class="btn btn-primary btn--full-width">see similar items</a><div class="fullscreen-overlay__or-block"><span>or</span></div><div>See New In from <em><a href="'+
((__t=( context.designerLink ))==null?'':_.escape(__t))+
'">'+
((__t=( context.designer ))==null?'':_.escape(__t))+
'</a></em></div></div></div>';
return __p;
};
    